import React from 'react';
import { LANGS } from './i18n';

export default function LanguageSwitcher({ lang, onChange }) {
  return (
    <select
      value={lang}
      onChange={e => onChange(e.target.value)}
      style={{ background: '#0a0d14', color: '#e4e6eb', border: '1px solid #2a2e3a', borderRadius: 6, padding: '6px 10px', fontSize: 13, cursor: 'pointer' }}
      aria-label="Language"
    >
      {LANGS.map(l => <option key={l.code} value={l.code}>{l.label}</option>)}
    </select>
  );
}
